export default __webpack_public_path__ + "static/media/1-009.e492ce48.jpg";